var items = {
  "block.minecraft.air": "въздух",
  "block.minecraft.stone": "камък",
  "block.minecraft.granite": "гранит",
  "block.minecraft.polished_granite": "полиран гранит",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "полиран диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "полиран андезит",
  "block.minecraft.grass_block": "тревист блок",
  "block.minecraft.dirt": "пръст",
  "block.minecraft.coarse_dirt": "едра пръст",
  "block.minecraft.podzol": "неплодородна почва",
  "block.minecraft.crimson_nylium": "пурпурен найлиум",
  "block.minecraft.warped_nylium": "шантав найлиум",
  "block.minecraft.cobblestone": "калдъръмени камъни",
  "block.minecraft.oak_planks": "дъбови дъски",
  "block.minecraft.spruce_planks": "смърчови дъски",
  "block.minecraft.birch_planks": "брезови дъски",
  "block.minecraft.jungle_planks": "джунглови дъски",
  "block.minecraft.acacia_planks": "акациеви дъски",
  "block.minecraft.dark_oak_planks": "дъски от черен дъб",
  "block.minecraft.crimson_planks": "пурпурни дъски",
  "block.minecraft.warped_planks": "шантави дъски",
  "block.minecraft.oak_sapling": "дъбова фиданка",
  "block.minecraft.spruce_sapling": "смърчова фиданка",
  "block.minecraft.birch_sapling": "брезова фиданка",
  "block.minecraft.jungle_sapling": "джунглова фиданка",
  "block.minecraft.acacia_sapling": "акациева фиданка",
  "block.minecraft.dark_oak_sapling": "фиданка на черен дъб",
  "block.minecraft.bedrock": "основен камък",
  "block.minecraft.sand": "пясък",
  "block.minecraft.red_sand": "червен пясък",
  "block.minecraft.gravel": "чакъл",
  "block.minecraft.gold_ore": "златна руда",
  "block.minecraft.iron_ore": "желязна руда",
  "block.minecraft.coal_ore": "въглищна руда",
  "block.minecraft.nether_gold_ore": "адска златна руда",
  "block.minecraft.oak_log": "дъбов дънер",
  "block.minecraft.spruce_log": "смърчов дънер",
  "block.minecraft.birch_log": "брезов дънер",
  "block.minecraft.jungle_log": "джунглов дънер",
  "block.minecraft.acacia_log": "акациев дънер",
  "block.minecraft.dark_oak_log": "дънер от черен дъб",
  "block.minecraft.crimson_stem": "пурпурно стъбло",
  "block.minecraft.warped_stem": "шантаво стъбло",
  "block.minecraft.stripped_oak_log": "оголен дъбов дънер",
  "block.minecraft.stripped_spruce_log": "оголен смърчов дънер",
  "block.minecraft.stripped_birch_log": "оголен брезов дънер",
  "block.minecraft.stripped_jungle_log": "оголен джунглов дънер",
  "block.minecraft.stripped_acacia_log": "оголен акациев дънер",
  "block.minecraft.stripped_dark_oak_log": "оголен дънер от черен дъб",
  "block.minecraft.stripped_crimson_stem": "оголено пурпурно стъбло",
  "block.minecraft.stripped_warped_stem": "оголено шантаво стъбло",
  "block.minecraft.stripped_oak_wood": "оголена дъбова дървесина",
  "block.minecraft.stripped_spruce_wood": "оголена смърчова дървесина",
  "block.minecraft.stripped_birch_wood": "оголена брезова дървесина",
  "block.minecraft.stripped_jungle_wood": "оголена джунглова дървесина",
  "block.minecraft.stripped_acacia_wood": "оголена акациева дървесина",
  "block.minecraft.stripped_dark_oak_wood": "оголена дървесина от черен дъб",
  "block.minecraft.stripped_crimson_hyphae": "оголени пурпурни хифи",
  "block.minecraft.stripped_warped_hyphae": "оголени шантави хифи",
  "block.minecraft.oak_wood": "дъбова дървесина",
  "block.minecraft.spruce_wood": "смърчова дървесина",
  "block.minecraft.birch_wood": "брезова дървесина",
  "block.minecraft.jungle_wood": "джунглова дървесина",
  "block.minecraft.acacia_wood": "акациева дървесина",
  "block.minecraft.dark_oak_wood": "дървесина от черен дъб",
  "block.minecraft.crimson_hyphae": "пурпурни хифи",
  "block.minecraft.warped_hyphae": "шантави хифи",
  "block.minecraft.oak_leaves": "дъбови листа",
  "block.minecraft.spruce_leaves": "смърчови листа",
  "block.minecraft.birch_leaves": "брезови листа",
  "block.minecraft.jungle_leaves": "джунглови листа",
  "block.minecraft.acacia_leaves": "акациеви листа",
  "block.minecraft.dark_oak_leaves": "листа от черен дъб",
  "block.minecraft.sponge": "гъба",
  "block.minecraft.wet_sponge": "мокра гъба",
  "block.minecraft.glass": "стъкло",
  "block.minecraft.lapis_ore": "лазуритна руда",
  "block.minecraft.lapis_block": "лазуритен блок",
  "block.minecraft.dispenser": "разпределител",
  "block.minecraft.sandstone": "пясъчник",
  "block.minecraft.chiseled_sandstone": "изписан пясъчник",
  "block.minecraft.cut_sandstone": "шлифован пясъчник",
  "block.minecraft.note_block": "музикален блок",
  "block.minecraft.powered_rail": "захранвани релси",
  "block.minecraft.detector_rail": "индикаторни релси",
  "block.minecraft.sticky_piston": "лепкаво бутало",
  "block.minecraft.cobweb": "паяжина",
  "block.minecraft.grass": "трева",
  "block.minecraft.fern": "папрат",
  "block.minecraft.dead_bush": "изсъхнал храст",
  "block.minecraft.seagrass": "морска трева",
  "block.minecraft.sea_pickle": "огнетелка",
  "block.minecraft.piston": "бутало",
  "block.minecraft.white_wool": "бяла вълна",
  "block.minecraft.orange_wool": "оранжева вълна",
  "block.minecraft.magenta_wool": "пурпурна вълна",
  "block.minecraft.light_blue_wool": "светлосиня вълна",
  "block.minecraft.yellow_wool": "жълта вълна",
  "block.minecraft.lime_wool": "жълтозеленa вълна",
  "block.minecraft.pink_wool": "розова вълна",
  "block.minecraft.gray_wool": "сива вълна",
  "block.minecraft.light_gray_wool": "светлосива вълна",
  "block.minecraft.cyan_wool": "синьозелена вълна",
  "block.minecraft.purple_wool": "лилава вълна",
  "block.minecraft.blue_wool": "синя вълна",
  "block.minecraft.brown_wool": "кафява вълна",
  "block.minecraft.green_wool": "зелена вълна",
  "block.minecraft.red_wool": "червена вълна",
  "block.minecraft.black_wool": "черна вълна",
  "block.minecraft.dandelion": "глухарче",
  "block.minecraft.poppy": "мак",
  "block.minecraft.blue_orchid": "синя орхидея",
  "block.minecraft.allium": "лук",
  "block.minecraft.azure_bluet": "лазурна метличина",
  "block.minecraft.red_tulip": "червено лале",
  "block.minecraft.orange_tulip": "оранжево лале",
  "block.minecraft.white_tulip": "бяло лале",
  "block.minecraft.pink_tulip": "розово лале",
  "block.minecraft.oxeye_daisy": "бяла маргаритка",
  "block.minecraft.cornflower": "синя метличина",
  "block.minecraft.lily_of_the_valley": "момина сълза",
  "block.minecraft.wither_rose": "уидър роза",
  "block.minecraft.brown_mushroom": "кафява гъба",
  "block.minecraft.red_mushroom": "червена гъба",
  "block.minecraft.crimson_fungus": "пурпурна гъба",
  "block.minecraft.warped_fungus": "шантава гъба",
  "block.minecraft.crimson_roots": "пурпурни корени",
  "block.minecraft.warped_roots": "шантави корени",
  "block.minecraft.nether_sprouts": "спори от недъра",
  "block.minecraft.weeping_vines": "плачещи лиани",
  "block.minecraft.twisting_vines": "увити лияни",
  "block.minecraft.sugar_cane": "захарна тръстика",
  "block.minecraft.kelp": "водорасло",
  "block.minecraft.bamboo": "бамбук",
  "block.minecraft.gold_block": "златен блок",
  "block.minecraft.iron_block": "железен блок",
  "block.minecraft.oak_slab": "дъбова плоча",
  "block.minecraft.spruce_slab": "смърчова плоча",
  "block.minecraft.birch_slab": "брезова плоча",
  "block.minecraft.jungle_slab": "джунглова плоча",
  "block.minecraft.acacia_slab": "акациева плоча",
  "block.minecraft.dark_oak_slab": "плоча от черен дъб",
  "block.minecraft.crimson_slab": "пурпурна плоча",
  "block.minecraft.warped_slab": "шантави дъски",
  "block.minecraft.stone_slab": "каменна плоча",
  "block.minecraft.smooth_stone_slab": "гладка каменна плоча",
  "block.minecraft.sandstone_slab": "плоча от пясъчник",
  "block.minecraft.cut_sandstone_slab": "плоча от сечен пясъчник",
  "block.minecraft.petrified_oak_slab": "вкаменена дъбова плоча",
  "block.minecraft.cobblestone_slab": "плоча от калдъръмени камъни",
  "block.minecraft.brick_slab": "тухлена плоча",
  "block.minecraft.stone_brick_slab": "плоча от каменни тухли",
  "block.minecraft.nether_brick_slab": "плоча от недъра",
  "block.minecraft.quartz_slab": "кварцова плоча",
  "block.minecraft.red_sandstone_slab": "плоча от червен пясъчник",
  "block.minecraft.cut_red_sandstone_slab": "плоча от сечен червен пясъчник",
  "block.minecraft.purpur_slab": "пурпурна плоча",
  "block.minecraft.prismarine_slab": "призмаринова плоча",
  "block.minecraft.prismarine_brick_slab": "плоча от призмаринови тухли",
  "block.minecraft.dark_prismarine_slab": "плоча от тъмен призмарин",
  "block.minecraft.smooth_quartz": "блок от гладък кварц",
  "block.minecraft.smooth_red_sandstone": "гладък червен пясъчник",
  "block.minecraft.smooth_sandstone": "гладък пясъчник",
  "block.minecraft.smooth_stone": "гладък камък",
  "block.minecraft.bricks": "тухли",
  "block.minecraft.tnt": "динамит",
  "block.minecraft.bookshelf": "рафтове с книги",
  "block.minecraft.mossy_cobblestone": "мъхести калдъръмени камъни",
  "block.minecraft.obsidian": "обсидиан",
  "block.minecraft.torch": "факла",
  "block.minecraft.end_rod": "пръчка от края",
  "block.minecraft.chorus_plant": "припевно растение",
  "block.minecraft.chorus_flower": "припевно цвете",
  "block.minecraft.purpur_block": "пурпурен блок",
  "block.minecraft.purpur_pillar": "пурпурна колона",
  "block.minecraft.purpur_stairs": "пурпурни стълби",
  "block.minecraft.spawner": "размножител",
  "block.minecraft.oak_stairs": "дъбови стъпала",
  "block.minecraft.chest": "сандък",
  "block.minecraft.diamond_ore": "диамантена руда",
  "block.minecraft.diamond_block": "диамантен блок",
  "block.minecraft.crafting_table": "работна маса",
  "block.minecraft.farmland": "обработваема земя",
  "block.minecraft.furnace": "пещ",
  "block.minecraft.ladder": "стълба",
  "block.minecraft.rail": "релса",
  "block.minecraft.cobblestone_stairs": "стъпала от калдъръмени камъни",
  "block.minecraft.lever": "ръчка",
  "block.minecraft.stone_pressure_plate": "каменна претегляща сигнална плоча",
  "block.minecraft.oak_pressure_plate": "дъбова претегляща сигнална плоча",
  "block.minecraft.spruce_pressure_plate": "смърчова претегляща сигнална плоча",
  "block.minecraft.birch_pressure_plate": "брезова претегляща сигнална плоча",
  "block.minecraft.jungle_pressure_plate": "джунглова претегляща сигнална плоча",
  "block.minecraft.acacia_pressure_plate": "акациева претегляща сигнална плоча",
  "block.minecraft.dark_oak_pressure_plate": "претегляща сигнална плоча от черен дъб",
  "block.minecraft.crimson_pressure_plate": "пурпурна сигнална плоча",
  "block.minecraft.warped_pressure_plate": "шантава сигнална плоча",
  "block.minecraft.polished_blackstone_pressure_plate": "сигнална плоча от полиран черен камък",
  "block.minecraft.redstone_ore": "червенокаменна руда",
  "block.minecraft.redstone_torch": "червенокаменна факла",
  "block.minecraft.snow": "сняг",
  "block.minecraft.ice": "лед",
  "block.minecraft.snow_block": "снежен блок",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "глина",
  "block.minecraft.jukebox": "джубокс",
  "block.minecraft.oak_fence": "дъбова ограда",
  "block.minecraft.spruce_fence": "смърчова ограда",
  "block.minecraft.birch_fence": "брезова ограда",
  "block.minecraft.jungle_fence": "джунглова ограда",
  "block.minecraft.acacia_fence": "акациева ограда",
  "block.minecraft.dark_oak_fence": "ограда от черен дъб",
  "block.minecraft.crimson_fence": "пурпурна ограда",
  "block.minecraft.warped_fence": "шантава ограда",
  "block.minecraft.pumpkin": "тиква",
  "block.minecraft.carved_pumpkin": "издълбана тиква",
  "block.minecraft.netherrack": "камък от недъра",
  "block.minecraft.soul_sand": "пясък на душите",
  "block.minecraft.soul_soil": "земя на душите",
  "block.minecraft.basalt": "базалт",
  "block.minecraft.polished_basalt": "полиран базалт",
  "block.minecraft.soul_torch": "обладана факла",
  "block.minecraft.glowstone": "сияещ камък",
  "block.minecraft.jack_o_lantern": "тиквен фенер",
  "block.minecraft.oak_trapdoor": "дъбов люк",
  "block.minecraft.spruce_trapdoor": "смърчов люк",
  "block.minecraft.birch_trapdoor": "брезов люк",
  "block.minecraft.jungle_trapdoor": "джунглов люк",
  "block.minecraft.acacia_trapdoor": "акациев люк",
  "block.minecraft.dark_oak_trapdoor": "люк от черен дъб",
  "block.minecraft.crimson_trapdoor": "пурпурен люк",
  "block.minecraft.warped_trapdoor": "шантав люк",
  "block.minecraft.infested_stone": "камък с люспеница",
  "block.minecraft.infested_cobblestone": "калдъръмени камъни с люспеница",
  "block.minecraft.infested_stone_bricks": "каменни тухли с люспеница",
  "block.minecraft.infested_mossy_stone_bricks": "мъхести калдъръмени камъни с люспеница",
  "block.minecraft.infested_cracked_stone_bricks": "напукани каменни тухли с люспеница",
  "block.minecraft.infested_chiseled_stone_bricks": "изписани каменни тухли с люспеница",
  "block.minecraft.stone_bricks": "каменни тухли",
  "block.minecraft.mossy_stone_bricks": "мъхести каменни тухли",
  "block.minecraft.cracked_stone_bricks": "напукани каменни тухли",
  "block.minecraft.chiseled_stone_bricks": "изписани каменни тухли",
  "block.minecraft.brown_mushroom_block": "кафяв гъбен блок",
  "block.minecraft.red_mushroom_block": "червен гъбен блок",
  "block.minecraft.mushroom_stem": "стебло на гъба",
  "block.minecraft.iron_bars": "железни решетки",
  "block.minecraft.chain": "верига",
  "block.minecraft.glass_pane": "стъклен панел",
  "block.minecraft.melon": "диня",
  "block.minecraft.vine": "лиани",
  "block.minecraft.oak_fence_gate": "дъбова порта",
  "block.minecraft.spruce_fence_gate": "смърчова порта",
  "block.minecraft.birch_fence_gate": "брезова порта",
  "block.minecraft.jungle_fence_gate": "джунглова порта",
  "block.minecraft.acacia_fence_gate": "акациева порта",
  "block.minecraft.dark_oak_fence_gate": "порта от черен дъб",
  "block.minecraft.crimson_fence_gate": "пурпурна порта",
  "block.minecraft.warped_fence_gate": "шантава порта",
  "block.minecraft.brick_stairs": "тухлени стъпала",
  "block.minecraft.stone_brick_stairs": "каменно-тухлени стъпала",
  "block.minecraft.mycelium": "мицел",
  "block.minecraft.lily_pad": "водна лилия",
  "block.minecraft.nether_bricks": "тухли от недъра",
  "block.minecraft.cracked_nether_bricks": "напукани тухли от недъра",
  "block.minecraft.chiseled_nether_bricks": "дялани тухли от недъра",
  "block.minecraft.nether_brick_fence": "тухлена ограда от недъра",
  "block.minecraft.nether_brick_stairs": "тухлени стъпала от недъра",
  "block.minecraft.enchanting_table": "чародейска маса",
  "block.minecraft.end_portal_frame": "рамка на портал към края",
  "block.minecraft.end_stone": "камък от края",
  "block.minecraft.end_stone_bricks": "тухли от края",
  "block.minecraft.dragon_egg": "драконово яйце",
  "block.minecraft.redstone_lamp": "червенокаменна лампа",
  "block.minecraft.sandstone_stairs": "стъпала от пясъчник",
  "block.minecraft.emerald_ore": "смарагдова руда",
  "block.minecraft.ender_chest": "сандък от края",
  "block.minecraft.tripwire_hook": "кука за капани",
  "block.minecraft.emerald_block": "смарагдов блок",
  "block.minecraft.spruce_stairs": "смърчови стъпала",
  "block.minecraft.birch_stairs": "брезови стъпала",
  "block.minecraft.jungle_stairs": "джунглови стъпала",
  "block.minecraft.crimson_stairs": "пурпурни стъпала",
  "block.minecraft.warped_stairs": "шантави стъпала",
  "block.minecraft.command_block": "команден блок",
  "block.minecraft.beacon": "маяк",
  "block.minecraft.cobblestone_wall": "калдъръмена стена",
  "block.minecraft.mossy_cobblestone_wall": "мъхеста калдъръмена стена",
  "block.minecraft.brick_wall": "тухлена стена",
  "block.minecraft.prismarine_wall": "призмаринова стена",
  "block.minecraft.red_sandstone_wall": "стена от червен пясъчник",
  "block.minecraft.mossy_stone_brick_wall": "стена от мъхести каменни тухли",
  "block.minecraft.granite_wall": "стена от гранит",
  "block.minecraft.stone_brick_wall": "стена от каменни тухли",
  "block.minecraft.nether_brick_wall": "стена от тухли от недъра",
  "block.minecraft.andesite_wall": "стена от андезит",
  "block.minecraft.red_nether_brick_wall": "стена от червени тухли от недъра",
  "block.minecraft.sandstone_wall": "стена от пясъчник",
  "block.minecraft.end_stone_brick_wall": "стена от тухли от края",
  "block.minecraft.diorite_wall": "стена от диорит",
  "block.minecraft.blackstone_wall": "стена от черен камък",
  "block.minecraft.polished_blackstone_wall": "полирана стена от черен камък",
  "block.minecraft.polished_blackstone_brick_wall": "полирана тухлена стена от черен камък",
  "block.minecraft.stone_button": "каменно копче",
  "block.minecraft.oak_button": "дъбово копче",
  "block.minecraft.spruce_button": "смърчово копче",
  "block.minecraft.birch_button": "брезово копче",
  "block.minecraft.jungle_button": "джунглово копче",
  "block.minecraft.acacia_button": "акациево копче",
  "block.minecraft.dark_oak_button": "копче от черен дъб",
  "block.minecraft.crimson_button": "пурпурен бутон",
  "block.minecraft.warped_button": "шантав бутон",
  "block.minecraft.polished_blackstone_button": "бутон от полиран черен камък",
  "block.minecraft.anvil": "наковалня",
  "block.minecraft.chipped_anvil": "очукана наковалня",
  "block.minecraft.damaged_anvil": "повредена наковалня",
  "block.minecraft.trapped_chest": "сандък с капан",
  "block.minecraft.light_weighted_pressure_plate": "лекочувствителна сигнална плоча",
  "block.minecraft.heavy_weighted_pressure_plate": "тежкочувствителна сигнална плоча",
  "block.minecraft.daylight_detector": "датчик за дневна светлина",
  "block.minecraft.redstone_block": "червенокаменен блок",
  "block.minecraft.nether_quartz_ore": "кварцова руда от недъра",
  "block.minecraft.hopper": "фуния",
  "block.minecraft.chiseled_quartz_block": "изписан кварцов блок",
  "block.minecraft.quartz_block": "кварцов блок",
  "block.minecraft.quartz_bricks": "кварцови тухли",
  "block.minecraft.quartz_pillar": "кварцова колона",
  "block.minecraft.quartz_stairs": "кварцови стъпала",
  "block.minecraft.activator_rail": "активираща релса",
  "block.minecraft.dropper": "изпускател",
  "block.minecraft.white_terracotta": "бяла теракота",
  "block.minecraft.orange_terracotta": "оранжева теракота",
  "block.minecraft.magenta_terracotta": "пурпурна теракота",
  "block.minecraft.light_blue_terracotta": "светлосиня теракота",
  "block.minecraft.yellow_terracotta": "жълта теракота",
  "block.minecraft.lime_terracotta": "жълтозелена теракота",
  "block.minecraft.pink_terracotta": "розова теракота",
  "block.minecraft.gray_terracotta": "сива теракота",
  "block.minecraft.light_gray_terracotta": "светлосива теракота",
  "block.minecraft.cyan_terracotta": "синьозелена теракота",
  "block.minecraft.purple_terracotta": "лилава теракота",
  "block.minecraft.blue_terracotta": "синя теракота",
  "block.minecraft.brown_terracotta": "кафява теракота",
  "block.minecraft.green_terracotta": "зелена теракота",
  "block.minecraft.red_terracotta": "червена теракота",
  "block.minecraft.black_terracotta": "черна теракота",
  "block.minecraft.barrier": "бариера",
  "block.minecraft.iron_trapdoor": "железен люк",
  "block.minecraft.hay_block": "слама",
  "block.minecraft.white_carpet": "бял килим",
  "block.minecraft.orange_carpet": "оранжев килим",
  "block.minecraft.magenta_carpet": "пурпурен килим",
  "block.minecraft.light_blue_carpet": "светлосин килим",
  "block.minecraft.yellow_carpet": "жълт килим",
  "block.minecraft.lime_carpet": "жълтозелен килим",
  "block.minecraft.pink_carpet": "розов килим",
  "block.minecraft.gray_carpet": "сив килим",
  "block.minecraft.light_gray_carpet": "светлосив килим",
  "block.minecraft.cyan_carpet": "синьозелен килим",
  "block.minecraft.purple_carpet": "лилав килим",
  "block.minecraft.blue_carpet": "син килим",
  "block.minecraft.brown_carpet": "кафяв килим",
  "block.minecraft.green_carpet": "зелен килим",
  "block.minecraft.red_carpet": "червен килим",
  "block.minecraft.black_carpet": "черен килим",
  "block.minecraft.terracotta": "теракота",
  "block.minecraft.coal_block": "въглищен блок",
  "block.minecraft.packed_ice": "втвърден лед",
  "block.minecraft.acacia_stairs": "акациеви стъпала",
  "block.minecraft.dark_oak_stairs": "стъпала от черен дъб",
  "block.minecraft.slime_block": "блок от слуз",
  "block.minecraft.grass_path": "тревна пътека",
  "block.minecraft.sunflower": "слънчоглед",
  "block.minecraft.lilac": "люляк",
  "block.minecraft.rose_bush": "розов храст",
  "block.minecraft.peony": "божур",
  "block.minecraft.tall_grass": "висока трева",
  "block.minecraft.large_fern": "голям папрат",
  "block.minecraft.white_stained_glass": "бяло стъкло",
  "block.minecraft.orange_stained_glass": "оранжево стъкло",
  "block.minecraft.magenta_stained_glass": "пурпурно стъкло",
  "block.minecraft.light_blue_stained_glass": "светлосиньо стъкло",
  "block.minecraft.yellow_stained_glass": "жълто стъкло",
  "block.minecraft.lime_stained_glass": "жълтозелено стъкло",
  "block.minecraft.pink_stained_glass": "розово стъкло",
  "block.minecraft.gray_stained_glass": "сиво стъкло",
  "block.minecraft.light_gray_stained_glass": "светлосиво стъкло",
  "block.minecraft.cyan_stained_glass": "синьозеленo стъкло",
  "block.minecraft.purple_stained_glass": "лилаво стъкло",
  "block.minecraft.blue_stained_glass": "синьо стъкло",
  "block.minecraft.brown_stained_glass": "кафяво стъкло",
  "block.minecraft.green_stained_glass": "зелено стъкло",
  "block.minecraft.red_stained_glass": "червено стъкло",
  "block.minecraft.black_stained_glass": "черно стъкло",
  "block.minecraft.white_stained_glass_pane": "бял стъклен панел",
  "block.minecraft.orange_stained_glass_pane": "оранжев стъклен панел",
  "block.minecraft.magenta_stained_glass_pane": "пурпурен стъклен панел",
  "block.minecraft.light_blue_stained_glass_pane": "светлосин стъклен панел",
  "block.minecraft.yellow_stained_glass_pane": "жълт стъклен панел",
  "block.minecraft.lime_stained_glass_pane": "жълтозелен стъклен панел",
  "block.minecraft.pink_stained_glass_pane": "розов стъклен панел",
  "block.minecraft.gray_stained_glass_pane": "сив стъклен панел",
  "block.minecraft.light_gray_stained_glass_pane": "светлосив стъклен панел",
  "block.minecraft.cyan_stained_glass_pane": "синьозелен стъклен панел",
  "block.minecraft.purple_stained_glass_pane": "лилав стъклен панел",
  "block.minecraft.blue_stained_glass_pane": "син стъклен панел",
  "block.minecraft.brown_stained_glass_pane": "кафяв стъклен панел",
  "block.minecraft.green_stained_glass_pane": "зелен стъклен панел",
  "block.minecraft.red_stained_glass_pane": "червен стъклен панел",
  "block.minecraft.black_stained_glass_pane": "черен стъклен панел",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "призмаринови тухли",
  "block.minecraft.dark_prismarine": "тъмен призмарин",
  "block.minecraft.prismarine_stairs": "призмаринови стъпала",
  "block.minecraft.prismarine_brick_stairs": "стъпала от призмаринови тухли",
  "block.minecraft.dark_prismarine_stairs": "стъпала от тъмен призмарин",
  "block.minecraft.sea_lantern": "морски фенер",
  "block.minecraft.red_sandstone": "червен пясъчник",
  "block.minecraft.chiseled_red_sandstone": "изписан червен пясъчник",
  "block.minecraft.cut_red_sandstone": "шлифован червен пясъчник",
  "block.minecraft.red_sandstone_stairs": "стъпала от червен пясъчник",
  "block.minecraft.repeating_command_block": "повтарящ команден блок",
  "block.minecraft.chain_command_block": "верижен команден блок",
  "block.minecraft.magma_block": "блок от магма",
  "block.minecraft.nether_wart_block": "блок от брадавица от недъра",
  "block.minecraft.warped_wart_block": "шантав брадавичен блок",
  "block.minecraft.red_nether_bricks": "червени тухли от недъра",
  "block.minecraft.bone_block": "костен блок",
  "block.minecraft.structure_void": "конструкционна празнота",
  "block.minecraft.observer": "наблюдател",
  "block.minecraft.shulker_box": "шулкърова кутия",
  "block.minecraft.white_shulker_box": "бяла шулкърова кутия",
  "block.minecraft.orange_shulker_box": "оранжева шулкърова кутия",
  "block.minecraft.magenta_shulker_box": "пурпурна шулкърова кутия",
  "block.minecraft.light_blue_shulker_box": "светлосиня шулкърова кутия",
  "block.minecraft.yellow_shulker_box": "жълта шулкърова кутия",
  "block.minecraft.lime_shulker_box": "жълтозелена шулкърова кутия",
  "block.minecraft.pink_shulker_box": "розова шулкърова кутия",
  "block.minecraft.gray_shulker_box": "сива шулкърова кутия",
  "block.minecraft.light_gray_shulker_box": "светлосива шулкърова кутия",
  "block.minecraft.cyan_shulker_box": "синьозелена шулкърова кутия",
  "block.minecraft.purple_shulker_box": "лилава шулкърова кутия",
  "block.minecraft.blue_shulker_box": "синя шулкърова кутия",
  "block.minecraft.brown_shulker_box": "кафява шулкърова кутия",
  "block.minecraft.green_shulker_box": "зелена шулкърова кутия",
  "block.minecraft.red_shulker_box": "червена шулкърова кутия",
  "block.minecraft.black_shulker_box": "черна шулкърова кутия",
  "block.minecraft.white_glazed_terracotta": "бяла глазирана теракота",
  "block.minecraft.orange_glazed_terracotta": "оранжева глазирана теракота",
  "block.minecraft.magenta_glazed_terracotta": "пурпурна глазирана теракота",
  "block.minecraft.light_blue_glazed_terracotta": "светлосиня глазирана теракота",
  "block.minecraft.yellow_glazed_terracotta": "жълта глазирана теракота",
  "block.minecraft.lime_glazed_terracotta": "жълтозелена глазирана теракота",
  "block.minecraft.pink_glazed_terracotta": "розова глазирана теракота",
  "block.minecraft.gray_glazed_terracotta": "сива глазирана теракота",
  "block.minecraft.light_gray_glazed_terracotta": "светлосива глазирана теракота",
  "block.minecraft.cyan_glazed_terracotta": "синьозелена глазирана теракота",
  "block.minecraft.purple_glazed_terracotta": "лилава глазирана теракота",
  "block.minecraft.blue_glazed_terracotta": "синя глазирана теракота",
  "block.minecraft.brown_glazed_terracotta": "кафява глазирана теракота",
  "block.minecraft.green_glazed_terracotta": "зелена глазирана теракота",
  "block.minecraft.red_glazed_terracotta": "червена глазирана теракота",
  "block.minecraft.black_glazed_terracotta": "черна глазирана теракота",
  "block.minecraft.white_concrete": "бял бетон",
  "block.minecraft.orange_concrete": "оранжев бетон",
  "block.minecraft.magenta_concrete": "пурпурен бетон",
  "block.minecraft.light_blue_concrete": "светлосин бетон",
  "block.minecraft.yellow_concrete": "жълт бетон",
  "block.minecraft.lime_concrete": "жълтозелен бетон",
  "block.minecraft.pink_concrete": "розов бетон",
  "block.minecraft.gray_concrete": "сив бетон",
  "block.minecraft.light_gray_concrete": "светлосив бетон",
  "block.minecraft.cyan_concrete": "синьозелен бетон",
  "block.minecraft.purple_concrete": "лилав бетон",
  "block.minecraft.blue_concrete": "син бетон",
  "block.minecraft.brown_concrete": "кафяв бетон",
  "block.minecraft.green_concrete": "зелен бетон",
  "block.minecraft.red_concrete": "червен бетон",
  "block.minecraft.black_concrete": "черен бетон",
  "block.minecraft.white_concrete_powder": "бял цимент",
  "block.minecraft.orange_concrete_powder": "оранжев цимент",
  "block.minecraft.magenta_concrete_powder": "пурпурен цимент",
  "block.minecraft.light_blue_concrete_powder": "светлосин цимент",
  "block.minecraft.yellow_concrete_powder": "жълт цимент",
  "block.minecraft.lime_concrete_powder": "жълтозелен цимент",
  "block.minecraft.pink_concrete_powder": "розов цимент",
  "block.minecraft.gray_concrete_powder": "сив цимент",
  "block.minecraft.light_gray_concrete_powder": "светлосив цимент",
  "block.minecraft.cyan_concrete_powder": "синьозелен цимент",
  "block.minecraft.purple_concrete_powder": "лилав цимент",
  "block.minecraft.blue_concrete_powder": "син цимент",
  "block.minecraft.brown_concrete_powder": "кафяв цимент",
  "block.minecraft.green_concrete_powder": "зелен цимент",
  "block.minecraft.red_concrete_powder": "червен цимент",
  "block.minecraft.black_concrete_powder": "черен цимент",
  "block.minecraft.turtle_egg": "яйце на костенурка",
  "block.minecraft.dead_tube_coral_block": "блок от мъртъв тръбен корал",
  "block.minecraft.dead_brain_coral_block": "блок от мъртъв мозъчен корал",
  "block.minecraft.dead_bubble_coral_block": "блок от мъртъв мехурчест корал",
  "block.minecraft.dead_fire_coral_block": "блок от мъртъв огнен корал",
  "block.minecraft.dead_horn_coral_block": "блок от мъртъв рогов корал",
  "block.minecraft.tube_coral_block": "блок от тръбен корал",
  "block.minecraft.brain_coral_block": "блок от мозъчен корал",
  "block.minecraft.bubble_coral_block": "блок от мехурчест корал",
  "block.minecraft.fire_coral_block": "блок от огнен корал",
  "block.minecraft.horn_coral_block": "блок от рогов корал",
  "block.minecraft.tube_coral": "тръбообразен корал",
  "block.minecraft.brain_coral": "мозъчен корал",
  "block.minecraft.bubble_coral": "мехурчест корал",
  "block.minecraft.fire_coral": "огнен корал",
  "block.minecraft.horn_coral": "рогов корал",
  "block.minecraft.dead_brain_coral": "мъртъв мозъчен корал",
  "block.minecraft.dead_bubble_coral": "мъртъв мехурчест корал",
  "block.minecraft.dead_fire_coral": "мъртъв огнен корал",
  "block.minecraft.dead_horn_coral": "мъртъв рогов корал",
  "block.minecraft.dead_tube_coral": "мъртъв тръбен корал",
  "block.minecraft.tube_coral_fan": "тръбен мек корал",
  "block.minecraft.brain_coral_fan": "мозъчен мек корал",
  "block.minecraft.bubble_coral_fan": "мехурчест мек корал",
  "block.minecraft.fire_coral_fan": "огнен мек корал",
  "block.minecraft.horn_coral_fan": "рогов мек корал",
  "block.minecraft.dead_tube_coral_fan": "мъртъв тръбен мек корал",
  "block.minecraft.dead_brain_coral_fan": "мъртъв мозъчен мек корал",
  "block.minecraft.dead_bubble_coral_fan": "мъртъв мехурчест мек корал",
  "block.minecraft.dead_fire_coral_fan": "мъртъв огнен мек корал",
  "block.minecraft.dead_horn_coral_fan": "мъртъв рогов мек корал",
  "block.minecraft.blue_ice": "ледник",
  "block.minecraft.conduit": "воден маяк",
  "block.minecraft.polished_granite_stairs": "стъпала от полиран гранит",
  "block.minecraft.smooth_red_sandstone_stairs": "стъпала от гладък червен пясъчник",
  "block.minecraft.mossy_stone_brick_stairs": "стъпала от мъхести каменни тухли",
  "block.minecraft.polished_diorite_stairs": "стъпала от полиран диорит",
  "block.minecraft.mossy_cobblestone_stairs": "стъпала от мъхести калдъръмени камъни",
  "block.minecraft.end_stone_brick_stairs": "стъпала от тухли от края",
  "block.minecraft.stone_stairs": "стъпала от камък",
  "block.minecraft.smooth_sandstone_stairs": "стъпала от гладък пясъчник",
  "block.minecraft.smooth_quartz_stairs": "стъпала от гладък кварц",
  "block.minecraft.granite_stairs": "стъпала от гранит",
  "block.minecraft.andesite_stairs": "стъпала от андезит",
  "block.minecraft.red_nether_brick_stairs": "стъпала от червени тухли от недъра",
  "block.minecraft.polished_andesite_stairs": "стъпала от полиран андезит",
  "block.minecraft.diorite_stairs": "стъпала от диорит",
  "block.minecraft.polished_granite_slab": "плоча от полиран гранит",
  "block.minecraft.smooth_red_sandstone_slab": "плоча от гладък червен пясъчник",
  "block.minecraft.mossy_stone_brick_slab": "плоча от мъхести каменни тухли",
  "block.minecraft.polished_diorite_slab": "плоча от полиран диорит",
  "block.minecraft.mossy_cobblestone_slab": "плоча от мъхести калдъръмени камъни",
  "block.minecraft.end_stone_brick_slab": "плоча от тухли от края",
  "block.minecraft.smooth_sandstone_slab": "плоча от гладък пясъчник",
  "block.minecraft.smooth_quartz_slab": "плоча от гладък кварц",
  "block.minecraft.granite_slab": "плоча от гранит",
  "block.minecraft.andesite_slab": "плоча от андезит",
  "block.minecraft.red_nether_brick_slab": "плоча от червени тухли от недъра",
  "block.minecraft.polished_andesite_slab": "плоча от полиран андезит",
  "block.minecraft.diorite_slab": "плоча от диорит",
  "block.minecraft.scaffolding": "скеле",
  "block.minecraft.iron_door": "желязна врата",
  "block.minecraft.oak_door": "дъбова врата",
  "block.minecraft.spruce_door": "смърчова врата",
  "block.minecraft.birch_door": "брезова врата",
  "block.minecraft.jungle_door": "джунглова врата",
  "block.minecraft.acacia_door": "акациева врата",
  "block.minecraft.dark_oak_door": "врата от черен дъб",
  "block.minecraft.crimson_door": "пурпурна врата",
  "block.minecraft.warped_door": "шантава врата",
  "block.minecraft.repeater": "червенокаменен повторител",
  "block.minecraft.comparator": "червенокаменен сравнител",
  "block.minecraft.structure_block": "конструкционен блок",
  "block.minecraft.jigsaw": "сглобяващ блок",
  "item.minecraft.turtle_helmet": "черупка на костенурка□□когато на главата:□+2 броня",
  "item.minecraft.scute": "рогово щитче",
  "item.minecraft.iron_shovel": "желязна лопата□□когато в основната ръка:□+3.5 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.iron_pickaxe": "желязна кирка□□когато в основната ръка:□+3 нападателни щети□-2.8 скорост на атакуване",
  "item.minecraft.iron_axe": "желязна брадва□□когато в основната ръка:□+8 нападателни щети□-3.1 скорост на атакуване",
  "item.minecraft.flint_and_steel": "запалка",
  "item.minecraft.apple": "ябълка",
  "item.minecraft.bow": "лък",
  "item.minecraft.arrow": "стрела",
  "item.minecraft.coal": "каменни въглища",
  "item.minecraft.charcoal": "дървени въглища",
  "item.minecraft.diamond": "диамант",
  "item.minecraft.iron_ingot": "желязно кюлче",
  "item.minecraft.gold_ingot": "златно кюлче",
  "item.minecraft.netherite_ingot": "кюлче недърайт",
  "item.minecraft.netherite_scrap": "късче недърайт",
  "item.minecraft.iron_sword": "железен меч□□когато в основната ръка:□+5 нападателни щети□-2.4 скорост на атакуване",
  "item.minecraft.wooden_sword": "дървен меч□□когато в основната ръка:□+3 нападателни щети□-2.4 скорост на атакуване",
  "item.minecraft.wooden_shovel": "дървена лопата□□когато в основната ръка:□+1.5 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.wooden_pickaxe": "дървена кирка□□когато в основната ръка:□+1 нападателни щети□-2.8 скорост на атакуване",
  "item.minecraft.wooden_axe": "дървена брадва□□когато в основната ръка:□+6 нападателни щети□-3.2 скорост на атакуване",
  "item.minecraft.stone_sword": "каменен меч□□когато в основната ръка:□+4 нападателни щети□-2.4 скорост на атакуване",
  "item.minecraft.stone_shovel": "каменна лопата□□когато в основната ръка:□+2.5 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.stone_pickaxe": "каменна кирка□□когато в основната ръка:□+2 нападателни щети□-2.8 скорост на атакуване",
  "item.minecraft.stone_axe": "каменна брадва□□когато в основната ръка:□+8 нападателни щети□-3.2 скорост на атакуване",
  "item.minecraft.diamond_sword": "диамантен меч□□когато в основната ръка:□+6 нападателни щети□-2.4 скорост на атакуване",
  "item.minecraft.diamond_shovel": "диамантена лопата□□когато в основната ръка:□+4.5 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.diamond_pickaxe": "диамантена кирка□□когато в основната ръка:□+4 нападателни щети□-2.8 скорост на атакуване",
  "item.minecraft.diamond_axe": "диамантена брадва□□когато в основната ръка:□+8 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.stick": "пръчка",
  "item.minecraft.bowl": "купа",
  "item.minecraft.mushroom_stew": "гъбена супа",
  "item.minecraft.golden_sword": "златен меч□□когато в основната ръка:□+3 нападателни щети□-2.4 скорост на атакуване",
  "item.minecraft.golden_shovel": "златна лопата□□когато в основната ръка:□+1.5 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.golden_pickaxe": "златна кирка□□когато в основната ръка:□+1 нападателни щети□-2.8 скорост на атакуване",
  "item.minecraft.golden_axe": "златна брадва□□когато в основната ръка:□+6 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.netherite_sword": "меч от недърайт□□когато в основната ръка:□+7 нападателни щети□-2.4 скорост на атакуване",
  "item.minecraft.netherite_shovel": "лопата от недърайт□□когато в основната ръка:□+5.5 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.netherite_pickaxe": "кирка от недърайт□□когато в основната ръка:□+5 нападателни щети□-2.8 скорост на атакуване",
  "item.minecraft.netherite_axe": "брадва от недърайт□□когато в основната ръка:□+9 нападателни щети□-3 скорост на атакуване",
  "item.minecraft.string": "връв",
  "item.minecraft.feather": "перо",
  "item.minecraft.gunpowder": "барут",
  "item.minecraft.wooden_hoe": "дървена мотика□□когато в основната ръка:□-3 скорост на атакуване",
  "item.minecraft.stone_hoe": "каменна мотика□□когато в основната ръка:□-2 скорост на атакуване",
  "item.minecraft.iron_hoe": "желязна мотика□□когато в основната ръка:□-1 скорост на атакуване",
  "item.minecraft.diamond_hoe": "диамантена мотика□□когато в основната ръка:",
  "item.minecraft.golden_hoe": "златна мотика□□когато в основната ръка:□-3 скорост на атакуване",
  "item.minecraft.netherite_hoe": "мотика от недърайт□□когато в основната ръка:",
  "item.minecraft.wheat_seeds": "пшеничени семена",
  "item.minecraft.wheat": "пшеница",
  "item.minecraft.bread": "хляб",
  "item.minecraft.leather_helmet": "кожена шапка□□когато на главата:□+1 броня",
  "item.minecraft.leather_chestplate": "кожена туника□□когато на тялото:□+3 броня",
  "item.minecraft.leather_leggings": "кожени панталони□□когато на краката:□+2 броня",
  "item.minecraft.leather_boots": "кожени ботуши□□когато на стъпалата:□+1 броня",
  "item.minecraft.chainmail_helmet": "шлем на ризница□□когато на главата:□+2 броня",
  "item.minecraft.chainmail_chestplate": "ризница□□когато на тялото:□+5 броня",
  "item.minecraft.chainmail_leggings": "панталони на ризница□□когато на краката:□+4 броня",
  "item.minecraft.chainmail_boots": "ботуши на ризница□□когато на стъпалата:□+1 броня",
  "item.minecraft.iron_helmet": "железен шлем□□когато на главата:□+2 броня",
  "item.minecraft.iron_chestplate": "железен нагръдник□□когато на тялото:□+6 броня",
  "item.minecraft.iron_leggings": "железни панталони□□когато на краката:□+5 броня",
  "item.minecraft.iron_boots": "железни ботуши□□когато на стъпалата:□+2 броня",
  "item.minecraft.diamond_helmet": "диамантен шлем□□когато на главата:□+3 броня□+2 издръжливост на броня",
  "item.minecraft.diamond_chestplate": "диамантен нагръдник□□когато на тялото:□+8 броня□+2 издръжливост на броня",
  "item.minecraft.diamond_leggings": "диамантени панталони□□когато на краката:□+6 броня□+2 издръжливост на броня",
  "item.minecraft.diamond_boots": "диамантени ботуши□□когато на стъпалата:□+3 броня□+2 издръжливост на броня",
  "item.minecraft.golden_helmet": "златен шлем□□когато на главата:□+2 броня",
  "item.minecraft.golden_chestplate": "златен нагръдник□□когато на тялото:□+5 броня",
  "item.minecraft.golden_leggings": "златни панталони□□когато на краката:□+3 броня",
  "item.minecraft.golden_boots": "златни ботуши□□когато на стъпалата:□+1 броня",
  "item.minecraft.netherite_helmet": "шлем от недърайт□□когато на главата:□+3 броня□+3 издръжливост на броня□+1 устойчивост на отблъскване",
  "item.minecraft.netherite_chestplate": "нагръдник от недърайт□□когато на тялото:□+8 броня□+3 издръжливост на броня□+1 устойчивост на отблъскване",
  "item.minecraft.netherite_leggings": "панталони от недърайт□□когато на краката:□+6 броня□+3 издръжливост на броня□+1 устойчивост на отблъскване",
  "item.minecraft.netherite_boots": "ботуши от недърайт□□когато на стъпалата:□+3 броня□+3 издръжливост на броня□+1 устойчивост на отблъскване",
  "item.minecraft.flint": "кремък",
  "item.minecraft.porkchop": "сурова свинска пържола",
  "item.minecraft.cooked_porkchop": "печена свинска пържола",
  "item.minecraft.painting": "картина",
  "item.minecraft.golden_apple": "златна ябълка",
  "item.minecraft.enchanted_golden_apple": "омагьосана златна ябълка",
  "block.minecraft.oak_sign": "дъбова табела",
  "block.minecraft.spruce_sign": "смърчова табела",
  "block.minecraft.birch_sign": "брезова табела",
  "block.minecraft.jungle_sign": "джунглова табела",
  "block.minecraft.acacia_sign": "акациева табела",
  "block.minecraft.dark_oak_sign": "табела от черен дъб",
  "block.minecraft.crimson_sign": "пурпурна табела",
  "block.minecraft.warped_sign": "шантава табела",
  "item.minecraft.bucket": "кофа",
  "item.minecraft.water_bucket": "кофа с вода",
  "item.minecraft.lava_bucket": "кофа с лава",
  "item.minecraft.minecart": "вагонетка",
  "item.minecraft.saddle": "седло",
  "item.minecraft.redstone": "червенокаменен прах",
  "item.minecraft.snowball": "снежна топка",
  "item.minecraft.oak_boat": "дъбова лодка",
  "item.minecraft.leather": "кожа",
  "item.minecraft.milk_bucket": "кофа с мляко",
  "item.minecraft.pufferfish_bucket": "кофа с риба балон",
  "item.minecraft.salmon_bucket": "кофа със сьомга",
  "item.minecraft.cod_bucket": "кофа с треска",
  "item.minecraft.tropical_fish_bucket": "кофа с тропическа риба",
  "item.minecraft.brick": "тухла",
  "item.minecraft.clay_ball": "топка глина",
  "block.minecraft.dried_kelp_block": "блокче от изсушени водорасли",
  "item.minecraft.paper": "хартия",
  "item.minecraft.book": "книга",
  "item.minecraft.slime_ball": "топка слуз",
  "item.minecraft.chest_minecart": "товарна вагонетка",
  "item.minecraft.furnace_minecart": "вагонетка с пещ",
  "item.minecraft.egg": "яйце",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "въдица",
  "item.minecraft.clock": "часовник",
  "item.minecraft.glowstone_dust": "прах от сияещ камък",
  "item.minecraft.cod": "сурова треска",
  "item.minecraft.salmon": "сурова сьомга",
  "item.minecraft.tropical_fish": "тропическа риба",
  "item.minecraft.pufferfish": "риба балон",
  "item.minecraft.cooked_cod": "печена треска",
  "item.minecraft.cooked_salmon": "сготвена сьомга",
  "item.minecraft.ink_sac": "мастило",
  "item.minecraft.red_dye": "червена боя",
  "item.minecraft.green_dye": "зелена боя",
  "item.minecraft.cocoa_beans": "какаови зърна",
  "item.minecraft.lapis_lazuli": "лазурит",
  "item.minecraft.purple_dye": "лилава боя",
  "item.minecraft.cyan_dye": "синьозелена боя",
  "item.minecraft.light_gray_dye": "светлосива боя",
  "item.minecraft.gray_dye": "сива боя",
  "item.minecraft.pink_dye": "розова боя",
  "item.minecraft.lime_dye": "жълтозеленa боя",
  "item.minecraft.yellow_dye": "жълта боя",
  "item.minecraft.light_blue_dye": "светлосиня боя",
  "item.minecraft.magenta_dye": "пурпурна боя",
  "item.minecraft.orange_dye": "оранжева боя",
  "item.minecraft.bone_meal": "стрити кости",
  "item.minecraft.blue_dye": "синя боя",
  "item.minecraft.brown_dye": "кафява боя",
  "item.minecraft.black_dye": "черна боя",
  "item.minecraft.white_dye": "бяла боя",
  "item.minecraft.bone": "кокал",
  "item.minecraft.sugar": "захар",
  "block.minecraft.cake": "торта",
  "block.minecraft.white_bed": "бяло легло",
  "block.minecraft.orange_bed": "оранжево легло",
  "block.minecraft.magenta_bed": "пурпурно легло",
  "block.minecraft.light_blue_bed": "светлосиньо легло",
  "block.minecraft.yellow_bed": "жълто легло",
  "block.minecraft.lime_bed": "жълтозелено легло",
  "block.minecraft.pink_bed": "розово легло",
  "block.minecraft.gray_bed": "сиво легло",
  "block.minecraft.light_gray_bed": "светлосиво легло",
  "block.minecraft.cyan_bed": "синьозелено легло",
  "block.minecraft.purple_bed": "лилаво легло",
  "block.minecraft.blue_bed": "синьо легло",
  "block.minecraft.brown_bed": "кафяво легло",
  "block.minecraft.green_bed": "зелено легло",
  "block.minecraft.red_bed": "червено легло",
  "block.minecraft.black_bed": "черно легло",
  "item.minecraft.cookie": "бисквитка",
  "item.minecraft.filled_map": "карта□#0",
  "item.minecraft.shears": "ножици",
  "item.minecraft.melon_slice": "резен диня",
  "item.minecraft.dried_kelp": "изсушени водорасли",
  "item.minecraft.pumpkin_seeds": "тиквени семена",
  "item.minecraft.melon_seeds": "динени семена",
  "item.minecraft.beef": "сурово говеждо месо",
  "item.minecraft.cooked_beef": "говежда пържола",
  "item.minecraft.chicken": "сурово пилешко месо",
  "item.minecraft.cooked_chicken": "печено пиле",
  "item.minecraft.rotten_flesh": "гнила плът",
  "item.minecraft.ender_pearl": "перла от края",
  "item.minecraft.blaze_rod": "пламенна пръчка",
  "item.minecraft.ghast_tear": "сълза на гаст",
  "item.minecraft.gold_nugget": "златен къшей",
  "item.minecraft.nether_wart": "брадавица от недъра",
  "item.minecraft.potion": "неизмайсторима отвара□без ефекти",
  "item.minecraft.glass_bottle": "стъкленица",
  "item.minecraft.spider_eye": "око на паяк",
  "item.minecraft.fermented_spider_eye": "ферментирало око на паяк",
  "item.minecraft.blaze_powder": "пламенен прах",
  "item.minecraft.magma_cream": "магмен крем",
  "block.minecraft.brewing_stand": "статив за отвари",
  "block.minecraft.cauldron": "казан",
  "item.minecraft.ender_eye": "око на края",
  "item.minecraft.glistering_melon_slice": "блестящ резен диня",
  "item.minecraft.bat_spawn_egg": "яйце на прилеп",
  "item.minecraft.bee_spawn_egg": "яйце на пчела",
  "item.minecraft.blaze_spawn_egg": "яйце на пламък",
  "item.minecraft.cat_spawn_egg": "яйце на котка",
  "item.minecraft.cave_spider_spawn_egg": "яйце на пещерен паяк",
  "item.minecraft.chicken_spawn_egg": "яйце на кокошка",
  "item.minecraft.cod_spawn_egg": "яйце на треска",
  "item.minecraft.cow_spawn_egg": "яйце на крава",
  "item.minecraft.creeper_spawn_egg": "яйце на крийпър",
  "item.minecraft.dolphin_spawn_egg": "яйце на делфин",
  "item.minecraft.donkey_spawn_egg": "яйце на магаре",
  "item.minecraft.drowned_spawn_egg": "яйце на удавник",
  "item.minecraft.elder_guardian_spawn_egg": "яйце на възрастен пазител",
  "item.minecraft.enderman_spawn_egg": "яйце на ендърмен",
  "item.minecraft.endermite_spawn_egg": "яйце на ендърмит",
  "item.minecraft.evoker_spawn_egg": "яйце на призовател",
  "item.minecraft.fox_spawn_egg": "яйце на лисица",
  "item.minecraft.ghast_spawn_egg": "яйце на гаст",
  "item.minecraft.guardian_spawn_egg": "яйце на пазител",
  "item.minecraft.hoglin_spawn_egg": "яйце на хоглин",
  "item.minecraft.horse_spawn_egg": "яйце на кон",
  "item.minecraft.husk_spawn_egg": "яйце на изсъхнало зомби",
  "item.minecraft.llama_spawn_egg": "яйце на лама",
  "item.minecraft.magma_cube_spawn_egg": "яйце на магмен куб",
  "item.minecraft.mooshroom_spawn_egg": "яйце на муухоморка",
  "item.minecraft.mule_spawn_egg": "яйце на муле",
  "item.minecraft.ocelot_spawn_egg": "яйце на оцелот",
  "item.minecraft.panda_spawn_egg": "яйце на панда",
  "item.minecraft.parrot_spawn_egg": "яйце на папагал",
  "item.minecraft.phantom_spawn_egg": "яйце на призрачна птица",
  "item.minecraft.pig_spawn_egg": "яйце на прасе",
  "item.minecraft.piglin_spawn_egg": "яйце на пиглин",
  "item.minecraft.pillager_spawn_egg": "яйце на разбойник",
  "item.minecraft.polar_bear_spawn_egg": "яйце на бяла мечка",
  "item.minecraft.pufferfish_spawn_egg": "яйце на риба балон",
  "item.minecraft.rabbit_spawn_egg": "яйце на заек",
  "item.minecraft.ravager_spawn_egg": "яйце на опустошител",
  "item.minecraft.salmon_spawn_egg": "яйце на сьомга",
  "item.minecraft.sheep_spawn_egg": "яйце на овца",
  "item.minecraft.shulker_spawn_egg": "яйце на шулкър",
  "item.minecraft.silverfish_spawn_egg": "яйце на люспеница",
  "item.minecraft.skeleton_spawn_egg": "яйце на скелет",
  "item.minecraft.skeleton_horse_spawn_egg": "яйце на скелетен кон",
  "item.minecraft.slime_spawn_egg": "яйце на слуз",
  "item.minecraft.spider_spawn_egg": "яйце на паяк",
  "item.minecraft.squid_spawn_egg": "яйце на сепия",
  "item.minecraft.stray_spawn_egg": "яйце на скелет скитник",
  "item.minecraft.strider_spawn_egg": "яйце на страйдър",
  "item.minecraft.trader_llama_spawn_egg": "яйце на лама на търговец",
  "item.minecraft.tropical_fish_spawn_egg": "яйце на тропическа риба",
  "item.minecraft.turtle_spawn_egg": "яйце на костенурка",
  "item.minecraft.vex_spawn_egg": "яйце на дразняч",
  "item.minecraft.villager_spawn_egg": "яйце на селянин",
  "item.minecraft.vindicator_spawn_egg": "яйце на бранител",
  "item.minecraft.wandering_trader_spawn_egg": "яйце на странстващ търговец",
  "item.minecraft.witch_spawn_egg": "яйце на вещица",
  "item.minecraft.wither_skeleton_spawn_egg": "яйце на yидър-скелет",
  "item.minecraft.wolf_spawn_egg": "яйце на вълк",
  "item.minecraft.zoglin_spawn_egg": "яйце на зоглин",
  "item.minecraft.zombie_spawn_egg": "яйце на зомби",
  "item.minecraft.zombie_horse_spawn_egg": "яйце на кон зомби",
  "item.minecraft.zombie_villager_spawn_egg": "яйце на селянин зомби",
  "item.minecraft.zombified_piglin_spawn_egg": "яйце на зомби пиглин",
  "item.minecraft.experience_bottle": "магическа колба",
  "item.minecraft.fire_charge": "огнен заряд",
  "item.minecraft.writable_book": "книга и перо",
  "item.minecraft.written_book": "написана книга",
  "item.minecraft.emerald": "смарагд",
  "item.minecraft.item_frame": "рамка",
  "block.minecraft.flower_pot": "саксия",
  "item.minecraft.carrot": "морков",
  "item.minecraft.potato": "картоф",
  "item.minecraft.baked_potato": "печен картоф",
  "item.minecraft.poisonous_potato": "отровен картоф",
  "item.minecraft.map": "празна карта",
  "item.minecraft.golden_carrot": "златен морков",
  "block.minecraft.skeleton_skull": "череп на скелет",
  "block.minecraft.wither_skeleton_skull": "череп на уидър-скелет",
  "block.minecraft.player_head": "глава на играч",
  "block.minecraft.zombie_head": "глава на зомби",
  "block.minecraft.creeper_head": "глава на крийпър",
  "block.minecraft.dragon_head": "глава на дракон",
  "item.minecraft.carrot_on_a_stick": "морков на клечка",
  "item.minecraft.warped_fungus_on_a_stick": "шантава гъба на пръчка",
  "item.minecraft.nether_star": "звезда от недъра",
  "item.minecraft.pumpkin_pie": "тиквен пай",
  "item.minecraft.firework_rocket": "фойерверк",
  "item.minecraft.firework_star": "звезда за фойерверк",
  "item.minecraft.enchanted_book": "омагьосана книга",
  "item.minecraft.nether_brick": "тухла от недъра",
  "item.minecraft.quartz": "кварц от недъра",
  "item.minecraft.tnt_minecart": "вагонетка с динамит",
  "item.minecraft.hopper_minecart": "вагонетка с фуния",
  "item.minecraft.prismarine_shard": "призмаринов къшей",
  "item.minecraft.prismarine_crystals": "призмаринови кристали",
  "item.minecraft.rabbit": "сурово заешко",
  "item.minecraft.cooked_rabbit": "сготвено заешко",
  "item.minecraft.rabbit_stew": "заешка яхния",
  "item.minecraft.rabbit_foot": "заешко краче",
  "item.minecraft.rabbit_hide": "заешка кожа",
  "item.minecraft.armor_stand": "стойка за броня",
  "item.minecraft.iron_horse_armor": "желязна конска броня",
  "item.minecraft.golden_horse_armor": "златна конска броня",
  "item.minecraft.diamond_horse_armor": "диамантена конска броня",
  "item.minecraft.leather_horse_armor": "кожена броня за кон",
  "item.minecraft.lead": "каишка",
  "item.minecraft.name_tag": "каишка с име",
  "item.minecraft.command_block_minecart": "вагонетка с команден блок",
  "item.minecraft.mutton": "сурово агнешко",
  "item.minecraft.cooked_mutton": "сготвено агнешко",
  "block.minecraft.white_banner": "бяло знаме",
  "block.minecraft.orange_banner": "оранжево знаме",
  "block.minecraft.magenta_banner": "пурпурно знаме",
  "block.minecraft.light_blue_banner": "светлосиньо знаме",
  "block.minecraft.yellow_banner": "жълто знаме",
  "block.minecraft.lime_banner": "жълтозелено знаме",
  "block.minecraft.pink_banner": "розово знаме",
  "block.minecraft.gray_banner": "сиво знаме",
  "block.minecraft.light_gray_banner": "светлосиво знаме",
  "block.minecraft.cyan_banner": "синьозелено знаме",
  "block.minecraft.purple_banner": "лилаво знаме",
  "block.minecraft.blue_banner": "синьо знаме",
  "block.minecraft.brown_banner": "кафяво знаме",
  "block.minecraft.green_banner": "зелено знаме",
  "block.minecraft.red_banner": "червено знаме",
  "block.minecraft.black_banner": "черно знаме",
  "item.minecraft.end_crystal": "кристал от края",
  "item.minecraft.chorus_fruit": "припевен плод",
  "item.minecraft.popped_chorus_fruit": "пукнат припевен плод",
  "item.minecraft.beetroot": "червено цвекло",
  "item.minecraft.beetroot_seeds": "семена за червено цвекло",
  "item.minecraft.beetroot_soup": "супа от червено цвекло",
  "item.minecraft.dragon_breath": "драконов дъх",
  "item.minecraft.splash_potion": "разплискваща се неизмайсторима отвара□без ефекти",
  "item.minecraft.spectral_arrow": "призрачна стрела",
  "item.minecraft.tipped_arrow": "неизмайсторима стрела с връх□без ефекти",
  "item.minecraft.lingering_potion": "задържаща се неизмайсторима отвара□без ефекти",
  "item.minecraft.shield": "щит",
  "item.minecraft.elytra": "криле",
  "item.minecraft.spruce_boat": "смърчова лодка",
  "item.minecraft.birch_boat": "брезова лодка",
  "item.minecraft.jungle_boat": "джунглова лодка",
  "item.minecraft.acacia_boat": "акациева лодка",
  "item.minecraft.dark_oak_boat": "лодка от черен дъб",
  "item.minecraft.totem_of_undying": "тотем на безсмъртието",
  "item.minecraft.shulker_shell": "черупка на шулкър",
  "item.minecraft.iron_nugget": "железен къшей",
  "item.minecraft.knowledge_book": "книга на знанието",
  "item.minecraft.debug_stick": "пръчка на промяната",
  "item.minecraft.music_disc_13": "музикална плоча□c418 - 13",
  "item.minecraft.music_disc_cat": "музикална плоча□c418 - cat",
  "item.minecraft.music_disc_blocks": "музикална плоча□c418 - blocks",
  "item.minecraft.music_disc_chirp": "музикална плоча□c418 - chirp",
  "item.minecraft.music_disc_far": "музикална плоча□c418 - far",
  "item.minecraft.music_disc_mall": "музикална плоча□c418 - mall",
  "item.minecraft.music_disc_mellohi": "музикална плоча□c418 - mellohi",
  "item.minecraft.music_disc_stal": "музикална плоча□c418 - stal",
  "item.minecraft.music_disc_strad": "музикална плоча□c418 - strad",
  "item.minecraft.music_disc_ward": "музикална плоча□c418 - ward",
  "item.minecraft.music_disc_11": "музикална плоча□c418 - 11",
  "item.minecraft.music_disc_wait": "музикална плоча□c418 - wait",
  "item.minecraft.music_disc_pigstep": "музикална плоча□лина рейн - pigstep",
  "item.minecraft.trident": "тризъбец□□когато в основната ръка:□+8 нападателни щети□-2.9 скорост на атакуване",
  "item.minecraft.phantom_membrane": "ципа на призрачна птица",
  "item.minecraft.nautilus_shell": "черупка на наутилус",
  "item.minecraft.heart_of_the_sea": "сърце на морето",
  "item.minecraft.crossbow": "арбалет",
  "item.minecraft.suspicious_stew": "подозрителна яхния",
  "block.minecraft.loom": "тъкачен стан",
  "item.minecraft.flower_banner_pattern": "шаблон за знаме□фигура на цвете",
  "item.minecraft.creeper_banner_pattern": "шаблон за знаме□фигура на крийпър",
  "item.minecraft.skull_banner_pattern": "шаблон за знаме□фигура на череп",
  "item.minecraft.mojang_banner_pattern": "шаблон за знаме□нещо",
  "item.minecraft.globe_banner_pattern": "шаблон за платно□земно кълбо",
  "item.minecraft.piglin_banner_pattern": "шаблон за знаме□зурла",
  "block.minecraft.composter": "компостер",
  "block.minecraft.barrel": "буре",
  "block.minecraft.smoker": "пушечна фурна",
  "block.minecraft.blast_furnace": "доменна пещ",
  "block.minecraft.cartography_table": "картографска маса",
  "block.minecraft.fletching_table": "маса за лъкове",
  "block.minecraft.grindstone": "точило",
  "block.minecraft.lectern": "поставка за книга",
  "block.minecraft.smithing_table": "коваческа маса",
  "block.minecraft.stonecutter": "каменоделски циркуляр",
  "block.minecraft.bell": "камбана",
  "block.minecraft.lantern": "фенер",
  "block.minecraft.soul_lantern": "фенер на душите",
  "item.minecraft.sweet_berries": "сладки горски плодове",
  "block.minecraft.campfire": "лагерен огън",
  "block.minecraft.soul_campfire": "душевен огън",
  "block.minecraft.shroomlight": "гъбена лампа",
  "item.minecraft.honeycomb": "медена пита",
  "block.minecraft.bee_nest": "пчелен кошер",
  "block.minecraft.beehive": "кошер",
  "item.minecraft.honey_bottle": "бутилка с мед",
  "block.minecraft.honey_block": "меден блок",
  "block.minecraft.honeycomb_block": "блок от медени пити",
  "block.minecraft.lodestone": "магнитен камък",
  "block.minecraft.netherite_block": "блок от недърайт",
  "block.minecraft.ancient_debris": "древни отломки",
  "block.minecraft.target": "мишена",
  "block.minecraft.crying_obsidian": "плачещ обсидиан",
  "block.minecraft.blackstone": "черен камък",
  "block.minecraft.blackstone_slab": "плоча от черен камък",
  "block.minecraft.blackstone_stairs": "стъпала от черен камък",
  "block.minecraft.gilded_blackstone": "позлатен черен камък",
  "block.minecraft.polished_blackstone": "полиран черен камък",
  "block.minecraft.polished_blackstone_slab": "полирана плоча от черен камък",
  "block.minecraft.polished_blackstone_stairs": "полирани стъпала от черен камък",
  "block.minecraft.chiseled_polished_blackstone": "дялан полиран черен камък",
  "block.minecraft.polished_blackstone_bricks": "полирани тухли от черен камък",
  "block.minecraft.polished_blackstone_brick_slab": "полирана плоча от чернокамъчни тухли",
  "block.minecraft.polished_blackstone_brick_stairs": "полирани чернокамъчни тухлени стълби",
  "block.minecraft.cracked_polished_blackstone_bricks": "пукнати полирани тухли от черен камък",
  "block.minecraft.respawn_anchor": "прераждаща котва",
}
export const bg_bg = items; 
